// src/lib/useAuth.ts
import { useContext } from 'react';
import { AuthContext, AuthState } from '../components/AuthWrapper';

export function useAuth() {
  return useContext(AuthContext) as AuthState;
}
